/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { QueryClient, QueryKey, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { queryOptions, useQuery } from '@tanstack/react-query';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import fetch from '../../client.ts';
import { getInvestmentDetailsQueryResponseSchema } from '../schemas/getInvestmentDetailsSchema.ts';
import type { GetInvestmentDetails505, GetInvestmentDetailsQueryResponse } from '../types/GetInvestmentDetails.ts';

export const getInvestmentDetailsQueryKey = () => ['USER_BACKEND', { url: '/investment_details' }] as const;

export type GetInvestmentDetailsQueryKey = ReturnType<typeof getInvestmentDetailsQueryKey>;

/**
 * {@link /investment_details}
 */
export async function getInvestmentDetails(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<GetInvestmentDetailsQueryResponse, ResponseErrorConfig<GetInvestmentDetails505>, unknown>({
    method: 'GET',
    url: `/investment_details`,
    ...requestConfig,
  });
  return getInvestmentDetailsQueryResponseSchema.parse(res.data);
}

export function getInvestmentDetailsQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = getInvestmentDetailsQueryKey();
  return queryOptions<
    GetInvestmentDetailsQueryResponse,
    ResponseErrorConfig<GetInvestmentDetails505>,
    GetInvestmentDetailsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getInvestmentDetails(config);
    },
  });
}

/**
 * {@link /investment_details}
 */
export function useGetInvestmentDetails<
  TData = GetInvestmentDetailsQueryResponse,
  TQueryData = GetInvestmentDetailsQueryResponse,
  TQueryKey extends QueryKey = GetInvestmentDetailsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetInvestmentDetailsQueryResponse,
        ResponseErrorConfig<GetInvestmentDetails505>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getInvestmentDetailsQueryKey();

  const query = useQuery(
    {
      ...getInvestmentDetailsQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<GetInvestmentDetails505>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
